// src/utils/time-ago.js — helper de tiempo relativo en español (27-may-2026).
//
// Extraído de las 3 copias duplicadas que vivían como closures locales en
// rituales.js (arengaCreatedAgo) y tribuna.js (idem, x2). Spec arengas v1.2 §5
// y §8 exige que el "Creado hace XX" sea visible siempre — un helper único
// garantiza formato consistente entre vistas.
//
// Acepta:
//   - número (ms desde epoch) — el shape que devolvía el closure viejo.
//   - string ISO (created_at de Supabase).
//   - Date.
//
// Formato:
//   - <1 min → "hace instantes"
//   - <60 min → "hace N min"
//   - <24h → "hace N h"
//   - resto → "hace N dia" / "hace N dias"

export const formatTimeAgo = (input, ahoraMs = Date.now()) => {
    if (input == null) return '';
    let ms;
    if (typeof input === 'number') ms = input;
    else if (input instanceof Date) ms = input.getTime();
    else { const d = new Date(input); ms = isNaN(d.getTime()) ? null : d.getTime(); }
    if (ms == null) return '';
    const diff = Math.max(0, ahoraMs - ms);
    const minutes = Math.floor(diff / 60000);
    if (minutes < 1) return 'hace instantes';
    if (minutes < 60) return `hace ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `hace ${hours} h`;
    const days = Math.floor(hours / 24);
    return days === 1 ? 'hace 1 dia' : `hace ${days} dias`;
};
